import axios from 'axios';
import * as Constants from "../common/constants";
import { InactiveIngredientAdminModel } from "../models/inactiveIngredient/inactiveIngredientAdminModel";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { InactiveIngredientFilterSettingsModel } from "../models/inactiveIngredient/inactiveIngredientFilterSettingsModel";
import AuthService from './authService';

class InactiveIngredientService {
	authService = new AuthService();

	constructor() {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Authorization: `Bearer ${this.authService.getToken()}`,
			Pragma: 'no-cache'
		}
	}

	getAllInactiveIngredients(from: number, numberOfRows: number, settings: InactiveIngredientFilterSettingsModel) {
		return axios({
			url: `adminInactiveIngredient/getAll/${from}/${numberOfRows}`,
			method: 'post', headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(settings)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getInactiveIngredient(id: number) {
		return axios({
			url: `adminInactiveIngredient/getById/${id}`,
			method: 'get'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	addInactiveIngredient(activeIngredient: InactiveIngredientAdminModel) {
		return axios({
			url: `adminInactiveIngredient/createInactiveIngredient`,
			method: 'post',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(activeIngredient)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	editInactiveIngredient(id: number, activeIngredient: InactiveIngredientAdminModel) {
		return axios({
			url: `adminInactiveIngredient/updateInactiveIngredient/${id}`,
			method: 'put',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(activeIngredient)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	deleteInactiveIngredient(id: number) {
		return axios({
			url: `adminInactiveIngredient/deleteInactiveIngredient/${id}`,
			method: 'delete'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}
}

export default InactiveIngredientService;
